export enum QuestionsTypes {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  FREEFORM = 'FREEFORM',
  SPECIFIC = 'SPECIFIC',
}
